import { QualifierAnswerObj } from './qualification-question-answer'
import { VettingEvalOutput } from './worker-vetting'

export enum IdealWorkerProfileCriteriaSourceType {
  QUALIFIER_ANSWER = 'QUALIFIER_ANSWER',
}

export enum IdealWorkerProfileCriteriaType {
  MAINTAINED_FULL_TIME_JOB = 'MAINTAINED_FULL_TIME_JOB',
  HAS_RECENT_WORK_EXPERIENCE = 'HAS_RECENT_WORK_EXPERIENCE',
  SEEKS_CONSISTENT_WORK = 'SEEKS_CONSISTENT_WORK',
  HAS_RELIABLE_TRANSPORTATION = 'HAS_RELIABLE_TRANSPORTATION',
  CAN_START_SOON = 'CAN_START_SOON',
  HAS_LIGHT_INDUSTRIAL_EXPERIENCE = 'HAS_LIGHT_INDUSTRIAL_EXPERIENCE',
  MATCHING_WAGE_EXPECTATION = 'MATCHING_WAGE_EXPECTATION',
  LIVES_IN_SUITABLE_ZIPCODE = 'LIVES_IN_SUITABLE_ZIPCODE',
}

type BaseIdealWorkerProfileCriteria = {
  id: string
  createdAt: Date
  updatedAt: Date
  workerId?: string
  ghostProfileId?: string
  criteriaType: IdealWorkerProfileCriteriaType
  score: number
  staleAt: Date
  sourceType: IdealWorkerProfileCriteriaSourceType
  archived: boolean
  archivedAt?: Date
}

export type QualifierAnswerIwpCriteria = BaseIdealWorkerProfileCriteria & {
  qualifierAnswerId: string
  qualifierAnswer: QualifierAnswerObj
}

export type VettingEvalOutputIwpCriteria = BaseIdealWorkerProfileCriteria & {
  vettingEvalOutputId: string
  vettingEvalOutput: VettingEvalOutput
}

export type IdealWorkerProfileCriteria =
  | QualifierAnswerIwpCriteria
  | VettingEvalOutputIwpCriteria

export enum IwpCriteriaEvaluationResult {
  PASSED = 'PASSED',
  FAILED = 'FAILED',
  INCONCLUSIVE = 'INCONCLUSIVE',
}
